import AxiosClient from "../../../services/axios.services";

class MeasurementUnitServices {
  getMeasurementUnit = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_datos_unidad_medida/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getMeasurementUnitById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_datos_unidad_medida/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveMeasurementUnit = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_datos_unidad_medida/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editMeasurementUnit = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_datos_unidad_medida/${id}/`, data, {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteMeasurementUnit = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_datos_unidad_medida/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new MeasurementUnitServices();
